/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';
import { Link } from 'react-router-dom';

import { I18n } from 'react-redux-i18n';
import ROUTES from '../../data/routes';

const Breadcrumb = ({ items }) => (
  <div className="container breadcrumb-container">
    <ol className="breadcrumb" itemScope itemType="https://schema.org/BreadcrumbList">
      <li itemProp="itemListElement" itemScope><Link to={ROUTES.HOME}><span itemProp="name">{I18n.t('home')}</span></Link></li>
      {items.map((item, index) => (
        <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" key={index} onClick={item.click ? item.click : null}>
          {item.link
            ? (
              <Link itemProp="item" to={item.link}>
                <span itemProp="name">{item.value}</span>
              </Link>
            )
            : (
              <a>
                <span itemProp="name">{item.value}</span>
              </a>
            )
          }
          <meta itemProp="position" content="1" />
        </li>
      ))}
    </ol>
  </div>
);

export default Breadcrumb;
